import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardModule } from '@fuse/components/card';
import { CreationAnalysisProgressComponent } from './creation-analysis-progress.component';

@NgModule({
  declarations: [CreationAnalysisProgressComponent],
  imports: [CommonModule, MatProgressBarModule, MatIconModule, FuseCardModule],
  exports: [CreationAnalysisProgressComponent],
})
export class CreationAnalysisProgressModule {}
